<script setup lang="ts">
    import AppLayout from '@/layouts/app/AppSidebarLayout.vue';
    import type { BreadcrumbItemType, SharedData } from '@/types';
    import AppToaster from '@/components/AppToaster.vue';
    import { computed, type HTMLAttributes } from 'vue';
    import NoCompanyPlaceholderCard from '@/components/NoCompanyPlaceholderCard.vue';
    import { usePage } from '@inertiajs/vue3';

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    interface Props {
        breadcrumbs?: BreadcrumbItemType[];
        headerClass?: HTMLAttributes['class'];
        contentClass?: HTMLAttributes['class'];
        hideHeader?: boolean;
        requireSelectedCompany?: boolean;
    }

    withDefaults(defineProps<Props>(), {
        breadcrumbs: () => [],
        requireSelectedCompany: false,
    });
</script>

<template>
    <AppLayout
        :breadcrumbs="breadcrumbs"
        :header-class="headerClass"
        :content-class="contentClass"
        :hide-header="hideHeader"
    >
        <template #header-actions>
            <slot name="header-actions" />
        </template>

        <slot v-if="!requireSelectedCompany || selectedCompanyId" />
        <NoCompanyPlaceholderCard v-else />

        <AppToaster />
    </AppLayout>
</template>
